const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const notification = require('actions/notifications');
const { FILTERS_VALID, REQUESTED_LIST_WALLETS } = require('constants/index');
const { APIPost } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;

function requestWalletInfoSuccess(groupedProducts, walletList) {
    return {
        type: actionTypes.BROKER_GET_STOCKS_BY_WALLET_SUCCESS,
        groupedProducts,
        walletList
    }
}

function requestWalletInfoFailure() {
    return {
        type: actionTypes.BROKER_GET_STOCKS_BY_WALLET_FAILURE
    }
}

function requestWalletInfoRequest() {
    return {
        type: actionTypes.BROKER_GET_STOCKS_BY_WALLET_REQUEST,
    }
}

const requestWalletStocks = () => (dispatch, getState) => {
    const contracts = getState().brokerWallets.get('walletList');
    const immStocksContracts = getState().brokerStocksContract;
    const groupedProducts = {};

    dispatch(requestWalletInfoRequest()); //just for backward compatibility
    contracts.forEach(
        contract => {
            const contractNumber = contract.getIn(['contract', 'numerodecontrato']);
            const productNumber = contract.getIn(['contract', 'producto']);
            const id = contractNumber + productNumber;

            const accountNumber = contract.get('accountNumber');
            const immStockContract = immStocksContracts.find(
                value => {
                    return value.get('walletNumber') === accountNumber;
                }
            );

            if (immStockContract) {
                const stockList = immStockContract.get('stocks');
                groupedProducts[id] = stockList;
            }
        }
    );
    //If we found all the contracts we are all right, if not we have an inconsistency
    if (contracts.size === Object.keys(groupedProducts).length) {
        dispatch(requestWalletInfoSuccess(groupedProducts, contracts.toJS()));
    }
    else {
        dispatch(requestWalletInfoFailure());
    }
}

function getWalletList() {
    return function() {
        // (Andres): Let's keep returning an empty promise for backawards compatibility
        return Promise.resolve();
    }
}

const getStocksByWallet = () => dispatch => {
    dispatch(requestWalletStocks());
}

const setFilterCustomWalletsInProgress = (walletId, alias, isCustomWalletSelected) => {
    const actionType = (!isCustomWalletSelected  ? actionTypes.SET_WALLET_ALIAS_REQUEST : actionTypes.CW_SET_WALLET_ALIAS_REQUEST);
    return {
        type: actionType,
        payload: {
            walletId,
            alias
        }
    };
};

const setFilterCustomWalletsSuccess = (walletId, alias, walletNumber, isCustomWalletSelected) => {
    const actionType = (!isCustomWalletSelected  ? actionTypes.SET_WALLET_ALIAS_SUCCESS : actionTypes.CW_SET_WALLET_ALIAS_SUCCESS);
    return {
        type: actionType,
        payload: {
            walletId,
            alias,
            walletNumber
        }
    };
};

const setFilterCustomWalletsFailure = (walletId, alias, isCustomWalletSelected) => {
    const actionType = (!isCustomWalletSelected  ? actionTypes.SET_WALLET_ALIAS_FAILURE : actionTypes.CW_SET_WALLET_ALIAS_FAILURE);
    return {
        type: actionType,
        payload: {
            walletId,
            alias
        }
    }
};

const setWalletAlias = (dispatch, getState, wallet, alias, oldAlias) => {
    const validFilter = FILTERS_VALID;
    const walletNumber = wallet.get('numerodecontrato');
    const walletId = wallet.get('producto') + walletNumber;
    const isCustomWalletSelected = getState().myWalletCharts.get('isCustomWalletSelected')

    const requestData = {
        query: {
            listaValores: {
                valores: [
                  {
                    contrato: {
                      numerodecontrato: wallet.get('numerodecontrato'),
                      producto: wallet.get('producto')
                    },
                    descripcion: oldAlias,
                    descripcionPersonalizada: alias,
                    filtroValido: validFilter,
                    filtroValidoPersonalizado: validFilter
                  }
                ]
            },
            listaSolicitada: REQUESTED_LIST_WALLETS
        }
    };

    dispatch(setFilterCustomWalletsInProgress(walletId, alias, isCustomWalletSelected));
    return APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings'), requestData)
        .then(() => {
            dispatch(setFilterCustomWalletsSuccess(walletId, alias, walletNumber, isCustomWalletSelected));
        })
        .catch(() => {
            const message = formatText('profile-edit_failure');
            dispatch(notification.error({message}, {voice: message}));
            dispatch(setFilterCustomWalletsFailure(walletId, oldAlias, isCustomWalletSelected));
        });
}

function postWalletAlias(contract, alias, oldAlias) {
    return function(dispatch, getState) {
        setWalletAlias(dispatch, getState, contract, alias, oldAlias);
    }
}

module.exports = {
    getWalletList,
    getStocksByWallet,
    setWalletAlias,
    postWalletAlias
}
